var _path, _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHxCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bandera",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.4 453.2",
    style: {
      enableBackground: "new 0 0 511.4 453.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.4,0H149c-15.1,0-29.1,8.1-36.7,21.2L5.7,205.4c-7.6,13.1-7.6,29.4,0,42.5l106.6,184.2c7.6,13.1,21.6,21.2,36.7,21.2 h213.4c15.1,0,29.1-8.1,36.7-21.2l106.6-184.2c7.6-13.1,7.6-29.4,0-42.5L399.1,21.2C391.5,8.1,377.5,0,362.4,0z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_CN_",
    d: "M118.3,432.8L8.4,242.5c-5.7-9.8-5.7-22,0-31.8L118.3,20.4c5.7-9.8,16.2-15.9,27.6-15.9h219.7 c11.4,0,21.9,6.1,27.5,15.9L503,210.7c5.7,9.8,5.7,22,0,31.8L393.1,432.8c-5.7,9.8-16.2,15.9-27.5,15.9H145.9 C134.5,448.7,124,442.7,118.3,432.8L118.3,432.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_CN_CLIP_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_CN_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_CN_CLIP_)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 511.4,
    height: 453.2,
    style: {
      fill: "#DE2910"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#FFDE00"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "125.00,74.00 135.33,105.78 168.75,105.79 141.71,125.43 152.04,157.21 125.00,137.57 97.96,157.21 108.29,125.43 81.25,105.79 114.67,105.78"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.52,81.89 195.83,73.49 190.10,63.93 200.35,68.29 207.67,59.89 206.69,70.99 216.94,75.35 206.08,77.85 205.11,88.94 199.37,79.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.15,106.84 227.16,101.93 225.58,90.90 233.34,98.90 243.34,93.99 238.13,103.84 245.89,111.83 234.91,109.93 229.71,119.77 228.13,108.75"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.59,146.45 228.72,146.05 231.78,135.34 235.60,145.81 246.74,145.41 237.97,152.28 241.78,162.74 232.54,156.52 223.77,163.39 226.83,152.68"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.69,171.75 200.12,175.68 207.08,166.99 206.56,178.11 216.98,182.04 206.24,184.99 205.72,196.12 199.60,186.81 188.86,189.76 195.82,181.06"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxCn);
export default __webpack_public_path__ + "static/media/hx-cn.7081748ab3904039f07a2b84d70baf52.svg";
export { ForwardRef as ReactComponent };